// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'; 
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
	root: {
	},
	checkboxInnerDiv: {
		minWidth: 32,
	},
	checkboxOutterDiv: {
	    display: "flex",
	},
	checkboxInputField: {
	    display: "inline-block",
	    position: "relative",
	},
	checkboxLabel: {
	    width: "1.5em",
	    height: "1.5em",
		cursor: "pointer",
	    margin: 0,
	    fontSize: "0.75em",
	},
	checkedBox: {
		color: "#00a4e4", 
		fontSize: "1.6em",
		textShadow: "2px 0 0px white",
	},
	description: {
	    paddingTop: "0.25em",
	},
	faBackground: {
	    color: "white",
	    fontSize: "1.7em",
	    top: "0.1em",
	},
});

interface PassInProperty {
	classes: object;
	label: string;
	onClick(updatedState: boolean): void;
	onLabelClick: void;
	allowDangerouslySetInnerHTML: string;
	isChecked?: boolean;
	id: string;
}

@withStyles(styles)
class CheckboxInputField extends React.Component<PassInProperty> {

	constructor(props){
		super(props);
		this.state = {
			checkState: typeof this.props.isChecked === "boolean" ? this.props.isChecked : false
		};
	}		
		
	onClickCheckbox:void = () => {
		const updatedCheckState = !this.state.checkState;

		this.setState({
			checkState: updatedCheckState
		});

		this.props.onClick(updatedCheckState);
	};
	
	render(){
		const { 		
		    classes, 			
			label, 
			onClick,
			onLabelClick,
			// inlineCheckbox,
			allowDangerouslySetInnerHTML,				
			id,	
		} = this.props
			
		// const checkboxFieldDisplayMode = (inlineCheckbox === true) ? 'inline-block' : 'block';	// Found that, old ko code makes no changes on two modes 
		const checkboxFieldDisplayMode = 'block';
		const isChecked = this.state.checkState;
		
		return (
			<div className={classes.root}>
			
				<div style={{ display: checkboxFieldDisplayMode }}>
					<div className={classes.checkboxOutterDiv}>
						<div className={classes.checkboxInnerDiv}>
							<div className={classes.checkboxInputField}>
								<div className={classes.checkboxLabel} id={id}>
									{(isChecked) ? ( 
										<div 
											className={`fa-stack fa-1x`} 
											onClick={this.onClickCheckbox} 
										>
											<i className={`fa fa-square fa-stack-2x ${classes.faBackground}`}></i>
											<i className={`fa fa-square-o fa-stack-2x`}></i>
											<i className={`fa fa-check fa-lg fa-stack-1x ${classes.checkedBox}`}></i>
										</div>
									) : (
										<div 
											className={`fa-stack fa-1x`}
											onClick={this.onClickCheckbox} 
										>
											<i className={`fa fa-square fa-stack-2x ${classes.faBackground}`}></i>
											<i className={`fa fa-square-o fa-stack-2x`}></i>
										</div>
									)}
								</div>
							</div>
						</div>
						<div onClick={this.onClickCheckbox} className={classes.description}>
							{allowDangerouslySetInnerHTML && allowDangerouslySetInnerHTML===true ? (
								<span onClick={onLabelClick} dangerouslySetInnerHTML={{__html: label}} />
							) : (
								<span onClick={onLabelClick}>
									{label}
								</span>
							)}
						</div>
					</div>
				</div>
			
			</div>
		);
	}
}

export default CheckboxInputField;